import { useQuery } from "@tanstack/react-query";
import { tradeService } from "@/services/tradeService";

export function useTradeBook() {
  return useQuery({ queryKey: ["trades", "book"], queryFn: tradeService.getTradeBook });
}
